import { S as Scrollbar } from './scrollbar-C3Ta89wQ.js';
import './utils-DfPPEfgu.js';
import './create-element-if-not-defined-BQEJuiIf.js';
import './classes-to-selector-BKH7ThcP.js';

/* eslint-disable wc/define-tag-after-class-definition, wc/no-constructor */

class SwiperExt extends HTMLElement {
  constructor() {
    super();
    this.#setupEventListeners();
  }

  /**
   * Sets up event listeners for the Swiper instance
   * @private
   */
  #setupEventListeners() {
    document.addEventListener('shopify:block:select', (event) => this.#onBlockSelect(event));
  }

  /**
   * Handles block selection events in the Shopify editor
   * @private
   * @param {Event} event - The block select event
   */
  #onBlockSelect({ target }) {
    const slide = target.closest('.swiper-slide');
    if (!slide) return;

    const slideIndex = this.swiperInstance.slides.indexOf(slide);
    this.swiperInstance.slideTo(slideIndex);
  }
}

class ProductUpsellSwiper extends SwiperExt {
  async connectedCallback() {
    await this.#initSwiper();
  }

  async #initSwiper() {
    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    try {
      const { Swiper } = await import('./swiper-BS-F1fmK.js');

      this.swiperInstance = new Swiper('.swiper--upsell', {
        modules: [Scrollbar],
        slidesPerView: 1.5,
        spaceBetween: 16,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },

        breakpoints: {
          1024: {
            slidesPerView: 1.75,
          },
        },
      });
    } catch (error) {
      console.error('Error initializing Upsell Swiper:', error);
    }
  }
}

customElements.define('product-upsell-swiper', ProductUpsellSwiper);
